import * as React from "react";
const SvgDashIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 10L15 10", stroke: "#9197A5", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDashIcon;
